import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { useUpdateShoppingCartMutation } from '../../../Apis/shoppingCartApi';
import { toastNotify } from '../../../Helper';
import { apiResponse, menuItemModel, userModel } from '../../../Interfaces'
import { RootState } from '../../../Storage/Redux/store';
import { MiniLoader } from '../Common';

interface Props{
    menuItem: menuItemModel;
}
function MenuItemCard(props: Props) {

  const nav = useNavigate()
  const [isAddingToCart, setAddingToCart]= useState<boolean>(false);
  const [updateShoppingCart] = useUpdateShoppingCartMutation(); 

  const userData: userModel = useSelector(
    (state: RootState) => state.userAuthStore
  );

const handleAddToCart = async (menuItemId:number)=>{
  if(sessionStorage.getItem("token")===null)
       {
        toastNotify("Please Login !!!","error")
        nav("/login")
        return 
       }
  setAddingToCart(true)

   const r : apiResponse= await updateShoppingCart({
      menuItemId: menuItemId,
      updateQuantityBy: 1,
      userId: userData.id
    })
    if (r.data && r.data.isSuccess) {
      toastNotify("Item added to cart successfully!");
    }

    setAddingToCart(false)
}

  return (
    <>
    <div className="col-md-4 col-12 p-4">
      <div
        className="card h-100"
        style={{ boxShadow: "0 1px 7px 0 rgb(0 0 0 / 50%)" }}
      >
        <div className="card-body pt-2">
        <Link to={`/item/${props.menuItem.id}`}>
          <div className="row col-10 offset-1 p-4">
          
            <img
              src={props.menuItem.image}
              style={{ borderRadius: "75%" }}
              alt=""
              className="w-70 h-100 mt-5 image-box"
            ></img>
             
          </div>
          </Link>

          {props.menuItem.specialTag &&
            props.menuItem.specialTag.length > 0 && (
              <i
                className="bi bi-star btn btn-success"
                style={{
                  position: "absolute",
                  top: "15px",
                  left: "15px",
                  padding: "5px 10px",
                  borderRadius: "3px",
                  outline: "none !important",
                  cursor: "pointer",
                }}
              >
                &nbsp; {props.menuItem.specialTag}
              </i>
            )}
          
          {isAddingToCart?(
            <>
            <div
             style={{
              position: "absolute",
              top: "15px",
              right: "15px",
            }}>
            <MiniLoader/>
            </div>
            </>):(
            <>
            <i
            className="bi bi-cart-plus btn btn-outline-danger"
            onClick={()=>handleAddToCart(props.menuItem.id)}
            style={{
              position: "absolute",
              top: "15px",
              right: "15px",
              padding: "5px 10px",
              borderRadius: "3px",
              outline: "none !important",
              cursor: "pointer",
            }}
            ></i>
            </>
          )}

          <div className="text-center">
          <Link to={`/item/${props.menuItem.id}`} style={{textDecoration: "none"}}>
            <p className="card-title m-0 text-success fs-3" 
                >{props.menuItem.name}</p>
            </Link>
            <p className="badge bg-secondary" style={{ fontSize: "12px" }}>
              {props.menuItem.category}
            </p>
          </div>
          <p className="card-text" style={{ textAlign: "center", color: "blue" }}>
            Read More ...
          </p>
          <div className="row text-center">
            <h4> &#x20b9; {props.menuItem.price}</h4>
          </div>
        </div>
      </div>
    </div>
    </>
  )
}

export default MenuItemCard